export default __webpack_public_path__ + "static/media/eazy-ask-response-submission.e37ca028.gif";